import { MessageCircle } from "lucide-react";

const VoiceAIButton = () => {
  return (
    <>
      {/* Floating "Just Click & Talk" label - visible on all devices */}
      <div className="fixed bottom-32 md:bottom-28 right-3 md:right-6 z-40 flex flex-col items-end gap-2">
        {/* "Just Click & Talk" label */}
        <div className="bg-gradient-to-r from-primary to-primary/80 text-primary-foreground px-4 py-2.5 rounded-full shadow-lg animate-pulse flex items-center gap-2 glow-teal">
          <MessageCircle className="w-4 h-4 md:w-5 md:h-5" />
          <span className="text-xs md:text-sm font-semibold whitespace-nowrap">Just Click & Talk!</span>
        </div>
      </div>
    </>
  );
};

export default VoiceAIButton;
